import _ from 'lodash'

export default function userRequired(props = {}) {
  const t = _.get(props, 't')
  const onContinue = _.get(props, 'onContinue')
  return {
    title: t('ui.userRequiredModal.title'),
    message: t('ui.userRequiredModal.description'),
    buttons: _.compact([
      {
        text: t('ui.userRequiredModal.buttons.continue'),
        onClick: onContinue,
      },
    ]),
  }
}
